import React, { useContext, useEffect, useState } from 'react';
import SearchBlock from '../SearchBlock';
import { RxCross2 } from 'react-icons/rx';
import feedaLogo from '../../assets/feedalogoWhite.svg';
import { TemporaryChatContext } from '../../Context/temporaryChatContext';
import { useParams } from 'react-router-dom';
import sessionsService from '../../services/sessionsServices';
import { AuthContext } from '../../Context/authContext';
import { useContextHook } from 'use-context-hook';
import SourcesTab from './Sources';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import 'swiper/css';
import 'swiper/css/navigation';
import { ChatSectionStyled, ChatColumn, SearchResultCol } from './ChatSection.styles';
import Markdown from 'react-markdown';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import teamService from '../../services/teamService';

const ChatSection = () => {
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const [activeTab, setActiveTab] = useState('Sources');
  const {
    selectedAgent,
    chatMessages,
    chatLoaderMessages,
    setChatmessages,
    setSessionAgent,
    sessionAgent,
    isActiveRef,
    toggleRef,
  } = useContext(TemporaryChatContext);
  const [selectedChatSources, setSelectedChatSources] = useState(null);
  const [teamDetails, setTeamDetails] = useState(null);
  const { id } = useParams();
  const tabs = ['Sources'];

  useEffect(() => {
    const fetchTeamData = async () => {
      if (selectedAgent?.mode === 'team' && selectedAgent?.value) {
        try {
          const res = await teamService?.getTeamDetails(selectedAgent.value);
          setTeamDetails(res?.detail);
        } catch (error) {
          console.error('Failed to fetch team details:', error);
        }
      }
    };

    fetchTeamData();
  }, [selectedAgent]);

  const getSessions = async id => {
    try {
      setChatmessages([]);
      const aiResp = await sessionsService.getSessionHistory({
        user_id: user?.data?.ID,
        platform_id: 'feedalabs',
        agent_id: 'ferdy',
        session_id: id,
      });
      if (aiResp?.agent_name) {
        setSessionAgent({ label: aiResp?.agent_name, value: aiResp?.agent_id, icon: aiResp?.icon });
      }
      const formattedMessages = aiResp?.history?.flatMap(item => {
        let isSource = item?.sources ? item?.sources : [];
        const websearchSources = isSource?.filter(src => src.type === 'google_search');
        const fileSources = isSource?.filter(src => src.type === 'file');
        return [
          {
            human: item.human,
            ai: item?.ai,
            source: websearchSources.length > 0 ? websearchSources : [],
            files: fileSources.length > 0 ? fileSources : [],
            images: item?.images,
            isLoading: false,
          },
        ];
      });

      setChatmessages(formattedMessages);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id && isActiveRef.current) {
      getSessions(id);
    }
  }, [id]);
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  function base64ToSrc(base64String, mimeType = 'image/png') {
    if (selectedAgent?.mode === 'team') {
      return selectedAgent?.icon;
    } else {
      if (!base64String?.icon) return null;
      if (base64String.icon.startsWith('http://') || base64String.icon.startsWith('https://')) {
        return base64String.icon;
      }
      return `data:${mimeType};base64,${base64String?.icon}`;
    }
  }

  return (
    <ChatSectionStyled className={selectedChatSources !== null ? 'sources-active' : ''}>
      <ChatColumn>
        <div className="text-block">
          {chatMessages?.map((elem, ind) => {
            return (
              <div key={ind}>
                {/* Human message */}
                {elem.human && (
                  <div className="heading user-text">
                    <div className="icon-box">{user?.first_name?.split('')[0]}</div>
                    <strong className="title">{elem?.human}</strong>
                    {(elem?.source?.length > 0 || elem?.files?.length > 0) && (
                      <button
                        className="see-source-button"
                        type="button"
                        style={{ border: ind === selectedChatSources && `2px solid var(--primary)` }}
                        onClick={() => setSelectedChatSources(ind)}>
                        see sources
                      </button>
                    )}
                  </div>
                )}

                {/* AI message */}
                <div className="heading">
                  {selectedAgent?.mode === 'team' && elem?.delegate_agent ? (
                    <div className="icon-box icon-box--purple">
                      <img
                        src={
                          teamDetails?.members.find(agent => {
                            const normalizedName = agent?.agent_name.toLowerCase().replace(/\s+/g, '-');

                            return normalizedName === elem?.delegate_agent;
                          })?.icon ?? feedaLogo
                        }
                        alt="Feeda logo"
                      />
                    </div>
                  ) : (
                    <div className="icon-box icon-box--purple">
                      <img src={base64ToSrc(sessionAgent) ?? feedaLogo} alt="Feeda logo" />
                    </div>
                  )}
                  {/* {elem.ai && elem.ai !== '' && elem?.isLoading === false && <Streamdown>{elem?.ai}</Streamdown>} */}
                  {elem?.images && elem?.images?.length > 0 && elem?.images !== '' && elem?.isLoading === false && (
                    <div className="swiper-holder">
                      <Swiper
                        slidesPerView={4.2}
                        navigation={{
                          prevEl: '.swiper-button-prev',
                          nextEl: '.swiper-button-next',
                        }}
                        modules={[Navigation]}
                        breakpoints={{
                          320: {
                            slidesPerView: 1.3,
                          },
                          574: {
                            slidesPerView: 2.2,
                          },
                          1250: {
                            slidesPerView: 2.8,
                          },
                          1440: {
                            slidesPerView: 3.2,
                          },
                          1750: {
                            slidesPerView: 4.2,
                          },
                        }}>
                        {elem?.images?.map((data, index) => (
                          <SwiperSlide>
                            <a href={data?.origin_url} target="blank" className="img-wrap" key={index}>
                              <img src={data?.image_url} alt="img" />
                            </a>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <div className="swiper-controls">
                        <button className="swiper-button-prev">
                          <IoIosArrowBack />
                        </button>
                        <button className="swiper-button-next">
                          <IoIosArrowForward />
                        </button>
                      </div>
                    </div>
                  )}

                  {elem.ai && elem.ai !== '' && elem?.isLoading === false && (
                    <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                      {elem?.ai}
                    </Markdown>
                  )}

                  {elem?.isLoading && (
                    <>
                      {chatLoaderMessages?.newChunk?.tool_name ? (
                        <strong className="chat-loader-text">{chatLoaderMessages?.newChunk?.tool_name}...</strong>
                      ) : (
                        <div style={{ width: '100%' }}>
                          {/* <Skeleton height={20} width={90} margin="10px" />
                        <Skeleton height={20} width={80} margin="5px" />
                        <Skeleton height={20} width={70} margin="5px" />
                        <Skeleton height={20} width={70} margin="5px" /> */}
                          <strong className="chat-loader-text">Thinking...</strong>
                        </div>
                      )}
                    </>
                  )}

                  {chatMessages?.length === ind + 1 && chatLoaderMessages?.newChunk?.tool_name && (
                    <strong className="chat-loader-text">{chatLoaderMessages?.newChunk?.tool_name}...</strong>
                  )}

                  {!elem.ai &&
                    !elem?.isLoading &&
                    (user?.usage?.api_calls >= user?.plan?.request_limit ? (
                      <span className="error-text">❌ Limit exceeded. Please upgrade your plan.</span>
                    ) : (
                      <span className="error-text">Something went wrong !!!</span>
                    ))}
                </div>
              </div>
            );
          })}

          <div className="reponse-block">
            <span className="agent-name">{sessionAgent?.label ?? 'Ferdy'}</span>
          </div>
        </div>
        <SearchBlock noMargin sessionId={id} />
      </ChatColumn>

      {selectedChatSources !== null && (
        <SearchResultCol>
          <div>
            <ul className="tablist">
              {tabs.map((tab, index) => (
                <li key={tab}>
                  <button key={index} className={tab === activeTab ? 'active' : ''} onClick={() => handleTabClick(tab)}>
                    {tab}
                  </button>
                </li>
              ))}
              <button type="button" className="source-close" title="close" onClick={() => setSelectedChatSources(null)}>
                <RxCross2 color="var(--danger)" />
              </button>
            </ul>
            <div className="tab-content">
              {activeTab === 'Sources' && <SourcesTab data={chatMessages[selectedChatSources]} />}
              {/* {activeTab === 'Images' && <ImageTab data={chatMessages[selectedChatSources]} />} */}
              {/*{activeTab === 'Videos' && <VideosTab />}
              {activeTab === 'News' && <NewsTab />} */}
            </div>
          </div>
        </SearchResultCol>
      )}
    </ChatSectionStyled>
  );
};

export default ChatSection;
